export class Error {
    code: string;
    statusText: string;
    messages: string[] = [];
}
